import React from "react";

const BRAND = {
  navy:   "#1A3A4A",
  blue:   "#2196C9",
  gold:   "#F5A623",
  bg:     "#F0F6FA",
  text:   "#1A3A4A",
  muted:  "#5A7A8A",
  border: "#D0E4EF",
  white:  "#ffffff",
};

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 36 }}>
      <h2 style={{
        fontSize: 16, fontWeight: 700, color: BRAND.navy,
        borderLeft: `3px solid ${BRAND.blue}`,
        paddingLeft: 12, margin: "0 0 12px",
      }}>{title}</h2>
      <div style={{ fontSize: 14, color: BRAND.muted, lineHeight: 1.8 }}>
        {children}
      </div>
    </div>
  );
}

function Para({ children }) {
  return <p style={{ margin: "0 0 10px" }}>{children}</p>;
}

export default function TermsPage({ onBack }) {
  return (
    <div style={{ minHeight: "100vh", background: BRAND.bg, fontFamily: "'Segoe UI', sans-serif" }}>

      {/* Header */}
      <div style={{
        background: BRAND.navy, padding: "0 32px", height: 52,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        position: "sticky", top: 0, zIndex: 100,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 20, fontWeight: 800, letterSpacing: -0.5 }}>
            <span style={{ color: BRAND.gold }}>Re</span>
            <span style={{ color: "#fff" }}>Zi</span>
          </span>
        </div>
        {onBack && (
          <button onClick={onBack} style={{
            background: "rgba(255,255,255,.08)", border: "1px solid rgba(255,255,255,.14)",
            borderRadius: 7, padding: "6px 14px", color: "rgba(255,255,255,.75)",
            fontSize: 12, cursor: "pointer",
          }}>← Back</button>
        )}
      </div>

      {/* Content */}
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "48px 24px 80px" }}>

        {/* Title block */}
        <div style={{ marginBottom: 40 }}>
          <div style={{ fontSize: 11, fontWeight: 600, textTransform: "uppercase",
            letterSpacing: "0.1em", color: BRAND.blue, marginBottom: 8 }}>
            Legal
          </div>
          <h1 style={{ fontSize: 32, fontWeight: 800, color: BRAND.navy, margin: "0 0 8px", letterSpacing: -0.5 }}>
            Terms of Service
          </h1>
          <p style={{ fontSize: 13, color: BRAND.muted, margin: 0 }}>
            Last updated: March 2026 &nbsp;·&nbsp; Effective date: March 2026
          </p>
        </div>

        <div style={{
          background: BRAND.white, borderRadius: 14, padding: "36px 40px",
          border: `1px solid ${BRAND.border}`,
          boxShadow: "0 2px 12px rgba(0,0,0,.04)",
        }}>

          <Section title="1. Acceptance of Terms">
            <Para>
              By accessing or using ReZi ("the Service"), operated by Hans Kruger t/a ReZi ("we", "us", "our"),
              you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.
            </Para>
            <Para>
              These terms apply to all users of the Service, including motor dealerships and individual subscribers.
            </Para>
          </Section>

          <Section title="2. Description of Service">
            <Para>
              ReZi is a web-based application that assists South African motor dealerships and individuals in
              completing government vehicle registration forms, specifically the RLV (Application for Registration
              and Licensing of Motor Vehicle) and NCO (Notification of Change of Ownership) forms.
            </Para>
            <Para>
              ReZi automates the population of officially prescribed form templates using information provided by
              the user. ReZi does not submit forms on behalf of users, does not interact with government systems,
              and is not a licensed vehicle registration service.
            </Para>
          </Section>

          <Section title="3. User Responsibilities">
            <Para>You are solely responsible for:</Para>
            <ul style={{ paddingLeft: 20, margin: "0 0 10px" }}>
              <li style={{ marginBottom: 6 }}>The accuracy and completeness of all information entered into the Service.</li>
              <li style={{ marginBottom: 6 }}>Ensuring that completed forms are submitted to the correct registering authority.</li>
              <li style={{ marginBottom: 6 }}>Obtaining consent from third parties whose personal information you enter into the Service.</li>
              <li style={{ marginBottom: 6 }}>Compliance with all applicable laws, including the National Road Traffic Act and POPIA.</li>
            </ul>
          </Section>

          <Section title="4. Subscription and Payment">
            <Para>
              Access to the Service is provided on a subscription basis. Pricing tiers are displayed on the
              pricing page and are subject to change with 30 days notice. Subscriptions are billed monthly.
              Overage charges apply at R15 per form generated beyond your plan's included allowance.
            </Para>
            <Para>
              Payments are processed by PayFast. We do not store your payment card details. Subscriptions
              may be cancelled at any time; cancellation takes effect at the end of the current billing period.
            </Para>
            <Para>
              New users receive a 7-day free trial with a limit of 7 forms. No payment details are required
              during the trial period.
            </Para>
          </Section>

          <Section title="5. Disclaimer of Warranties">
            <Para>
              The Service is provided "as is" and "as available" without warranties of any kind. We do not
              warrant that the Service will be error-free, uninterrupted, or that generated forms will be
              accepted by any registering authority.
            </Para>
            <Para>
              It is your responsibility to verify all completed forms before submission. ReZi accepts no
              liability for rejected or incorrectly completed forms.
            </Para>
          </Section>

          <Section title="6. Limitation of Liability">
            <Para>
              To the maximum extent permitted by applicable law, Hans Kruger t/a ReZi shall not be liable
              for any indirect, incidental, special, or consequential damages arising from your use of the
              Service, including but not limited to loss of revenue, data, or business opportunity.
            </Para>
            <Para>
              Our total liability to you for any claim arising from the use of the Service shall not exceed
              the amount paid by you to us in the three months preceding the claim.
            </Para>
          </Section>

          <Section title="7. Intellectual Property">
            <Para>
              The ReZi platform, including its design, code, and branding, is the intellectual property of
              Hans Kruger t/a ReZi. You may not copy, reproduce, or distribute any part of the Service
              without our prior written consent.
            </Para>
            <Para>
              The RLV and NCO form templates used by the Service are prescribed government documents issued
              under the National Road Traffic Act. ReZi claims no ownership over these templates.
            </Para>
          </Section>

          <Section title="8. Termination">
            <Para>
              We reserve the right to suspend or terminate your account at any time if you breach these Terms,
              engage in fraudulent activity, or use the Service in a manner that could harm other users or
              third parties.
            </Para>
          </Section>

          <Section title="9. Governing Law">
            <Para>
              These Terms are governed by the laws of the Republic of South Africa. Any disputes shall be
              subject to the jurisdiction of the South African courts.
            </Para>
          </Section>

          <Section title="10. Contact">
            <Para>
              For any questions regarding these Terms, contact us at{" "}
              <a href="mailto:rezi.support@gmail.com" style={{ color: BRAND.blue }}>rezi.support@gmail.com</a>.
            </Para>
          </Section>

        </div>

        {/* Footer link */}
        <div style={{ textAlign: "center", marginTop: 32, fontSize: 13, color: BRAND.muted }}>
          <a href="/privacy" style={{ color: BRAND.blue, textDecoration: "none", fontWeight: 600 }}>
            Privacy Policy
          </a>
          {" "}·{" "}
          <span>© 2026 Hans Kruger t/a ReZi · ReZi</span>
        </div>

      </div>
    </div>
  );
}
